<!-- //////////////// HEADER ///////////////////// -->

<div
  *ngIf="brandedPageMenuStyle"
  class="header-movie-menu-styles"
  [innerHTML]="brandedPageMenuStyle | safe: 'html'"
></div>

<div #headerThreshold id="header-threshold">
  <!-- Element to track the header position -->
</div>

<div
  class="header-wrapper"
  data-testid="header-wrapper"
  [ngClass]="headerCustomizationClass()"
  [class.noCollapsed]="isCollapse"
>
  <div id="header" class="page-content" data-testid="header">
    @if (elementLogoLocation === '2') {
      <ng-container *ngTemplateOutlet="logo" />
    }

    <div class="header-items" #headerItemsList>
      <!-- NOTE: Some old still use this element. By default is hide. -->
      <ng-container *ngTemplateOutlet="logo; context: { class: 'nav-logo-inside' }" />

      <ul class="header-links" role="menubar">
        @if (elementLogoLocation === '1') {
          <li class="nav-logo-menu-item" role="menuitem">
            <ng-container *ngTemplateOutlet="logo" />
          </li>
        }
        <li
          role="menuitem"
          *ngFor="let link of links"
          (click)="onHeaderLinkClicked(link)"
          [ngClass]="['nav-item', 'nav-' + link.name.replaceAll(' ', '-').toLowerCase()]"
        >
          <ng-container
            [ngTemplateOutlet]="linkTemplate"
            [ngTemplateOutletContext]="{ $implicit: link, isParent: link?.isParent }"
          ></ng-container>

          <div class="sub-menu {{ link.isActive ? 'active' : '' }}" (mouseleave)="link.isActive = false">
            <ul class="sub-menu-items" *ngIf="link?.children">
              <li
                *ngFor="let sublink of link?.children"
                (click)="onHeaderLinkClicked(sublink)"
                [ngClass]="['nav-item', 'nav-item-sub-menu', 'nav-' + sublink.name.replaceAll(' ', '-').toLowerCase()]"
              >
                <ng-container
                  [ngTemplateOutlet]="linkTemplate"
                  [ngTemplateOutletContext]="{ $implicit: sublink, class: 'nav-link-child', isChild: true }"
                ></ng-container>
              </li>
            </ul>
          </div>
        </li>
        @if (elementSearchLocation === '1') {
          <li class="search-item" role="menuitem">
            <div #searchItem id="search-component">
              <ush-search-movie [mode]="'desktop'" [classStyle]="'search-header'" />
            </div>
          </li>
        }
        @if (elementLoginLocation === '1') {
          <li role="menuitem" *ngIf="hasLogin">
            <ng-container [ngTemplateOutlet]="loginButton"></ng-container>
          </li>
        }

        <li *ngIf="hasTranslationHeader" role="menuitem">
          <div class="language-select-wrapper">
            <ush-language-selector></ush-language-selector>
          </div>
        </li>

        <ng-container *ngIf="headerCustomLinkTemplate">
          <ng-container [ngTemplateOutlet]="headerCustomLinkTemplate" />
        </ng-container>
      </ul>
    </div>

    @if (elementLoginLocation === '2' && hasLogin) {
      <ng-container [ngTemplateOutlet]="loginButton" />
    }

    <ng-content select="[extraHeaderElements]"></ng-content>

    <div *ngIf="hasSocialLinks" class="nav-socialLinks">
      <ush-social-links *ngIf="socialLinks?.length > 0" [socialNetworks]="socialLinks"></ush-social-links>
    </div>

    @if (elementSearchLocation === '2') {
      <div #searchItem id="search-component" class="search-item">
        <ush-search-movie [mode]="'desktop'" [classStyle]="'search-header'" />
      </div>
    }
  </div>

  <!-- //////////////// HEADER SM ////////////////// -->
  <ng-container *ngIf="!brandedPageLinks.length; else brandedPageHeaderSmall">
    <div id="header-sm" [class.noCollapsed]="isCollapse" class="page-content" data-testid="header-sm">
      <ng-container *ngTemplateOutlet="logo"></ng-container>
      <div class="header-items" [class.collapsed]="isCollapse">
        <!-- SEARCH IN TOP -->
        <ng-container *ngIf="headerSMsearchTop"> </ng-container>
        <ng-container *ngIf="hasTranslationHeader && !hasCollapsedTranslation">
          <!-- <ush-language-selector></ush-language-selector> -->
        </ng-container>
        <ng-container *ngIf="hasLogin">
          <ng-container [ngTemplateOutlet]="loginButton"></ng-container>
        </ng-container>
        <button
          (click)="toggleNavbar()"
          type="button"
          aria-label="Toggle navigation"
          class="navbar-toggler"
          data-testid="header-sm-menu-toggler"
          [ngClass]="!isCollapse ? 'navbar-toggler-bars' : 'navbar-toggler-times'"
        >
          <fa-icon [icon]="toggleIcon" class="navbar-toggler-icon"></fa-icon>
        </button>
      </div>

      <!-- MOBILE MENU ----------------------------------------------------------------------------->

      <div class="header-collapse-items" [class.collapsed]="isCollapse" data-testid="header-sm-menu">
        <ul class="header-links-sm">
          <ng-content select="[extraHeaderMobileElements]"></ng-content>
          @if (hasTranslationHeaderSM) {
            <li class="language-selector-collapse nav-item">
              <ush-language-selector></ush-language-selector>
            </li>
          }
          <!-- SEARCH IN COLLAPSE MENU -->
          <li *ngIf="headerSMsearchCollapse" [class]="['search-collapse', 'nav-item']">
            <ush-search-movie [mode]="'mobile'" (itemSelect)="toggleNavbar(null)"></ush-search-movie>
          </li>
          <li *ngIf="hasSocialLinks" class="nav-socialLinks">
            <ush-social-links *ngIf="socialLinks?.length > 0" [socialNetworks]="socialLinks"></ush-social-links>
          </li>
          <ng-container *ngFor="let link of links" (click)="onHeaderLinkClicked(link)">
            <!-- STANDARD SUB-LINK --------------------------------------------------->

            @if (!link?.accordion) {
              <li
                [ngClass]="['nav-item', 'nav-' + link.name.replaceAll(' ', '-').toLowerCase()]"
                [class.isParentItem]="link?.isParent"
              >
                <ng-container
                  [ngTemplateOutlet]="linkTemplate"
                  [ngTemplateOutletContext]="{ $implicit: link, isParent: link?.isParent }"
                ></ng-container>
              </li>

              <li
                *ngFor="let sublink of link?.children"
                (click)="onHeaderLinkClicked(sublink)"
                [ngClass]="[
                  'nav-item',
                  'nav-' + link.name.replaceAll(' ', '-').toLowerCase(),
                  'nav-child',
                  ' nav-child-' + link.name.replaceAll(' ', '-').toLowerCase()
                ]"
              >
                <ng-container
                  [ngTemplateOutlet]="linkTemplate"
                  [ngTemplateOutletContext]="{ $implicit: sublink }"
                ></ng-container>
              </li>
            } @else {
              <!-- ACCORDION SUB-LINK --------------------------------------------------->

              <li
                [ngClass]="['nav-item', 'nav-' + link.name.replaceAll(' ', '-').toLowerCase(), 'nav-accordion']"
                [class.isParentItem]="link?.isParent"
              >
                <p-accordion
                  [className]="'nav-accordion-header-sm'"
                  [activeIndex]="link.isActive ? 0 : link.accordion?.isInitiallyOpenCondition(link) ? 0 : null"
                  (onTabChange)="link.isActive = !link.isActive"
                >
                  <p-accordionTab>
                    <ng-template pTemplate="header">
                      <span class="nav-link bold">
                        {{ link.name | cammelCase | channelLinkLocalize: link.name }}
                      </span>
                    </ng-template>
                    <ng-template pTemplate="content">
                      <ul>
                        <li
                          *ngFor="let sublink of link?.children"
                          (click)="onHeaderLinkClicked(sublink)"
                          [ngClass]="[
                            'nav-item',
                            'nav-' + link.name.replaceAll(' ', '-').toLowerCase(),
                            'nav-child',
                            'nav-child-' + link.name.replaceAll(' ', '-').toLowerCase()
                          ]"
                        >
                          <ng-container
                            [ngTemplateOutlet]="linkTemplate"
                            [ngTemplateOutletContext]="{ $implicit: sublink }"
                          ></ng-container>
                        </li>
                      </ul>
                    </ng-template>
                  </p-accordionTab>
                </p-accordion>
              </li>
            }
          </ng-container>

          <!-- Collapsed menu translation widget -->
          <ng-container *ngIf="hasCollapsedTranslation">
            <!-- <ush-language-selector></ush-language-selector> -->
          </ng-container>
          <!-- header custom links mobile menu -->
          <ng-container *ngIf="headerCustomLinkTemplate">
            <ng-container
              [ngTemplateOutlet]="headerCustomLinkTemplate"
              [ngTemplateOutletContext]="{ $implicit: headerInstance }"
            ></ng-container>
          </ng-container>
        </ul>
      </div>
    </div>
  </ng-container>

  <!-- HEADER TOP SPAN -->
  <div class="header-span"></div>
</div>

<ng-template #brandedPageHeaderSmall>
  <div
    id="header-sm"
    data-testid="header-sm"
    [class.noCollapsed]="isCollapse"
    [class.header-sm-movie]="onMovieMenu"
    class="header-sm-branded-page"
  >
    <ng-container *ngTemplateOutlet="logo"></ng-container>
    <div class="header-items">
      <!-- SEARCH IN TOP -->
      <ng-container *ngIf="headerSMsearchTop">
        <!-- <ush-search-movie [mode]="'mobile'"></ush-search-movie> -->
      </ng-container>
      <ng-container *ngIf="hasLogin">
        <ng-container [ngTemplateOutlet]="loginButton"></ng-container>
      </ng-container>
      <button (click)="toggleNavbar()" type="button" class="navbar-toggler">
        <fa-icon [icon]="toggleIcon" class="navbar-toggler-icon"></fa-icon>
      </button>
    </div>

    <div class="header-collapse-items" [class.collapsed]="isCollapse && !onMovieMenu">
      <ul>
        <li *ngIf="hasSocialLinks" class="nav-socialLinks">
          <ush-social-links *ngIf="socialLinks.length > 0" [socialNetworks]="socialLinks"></ush-social-links>
        </li>
        <ng-container *ngFor="let link of links" (click)="onHeaderLinkClicked(link)">
          <li
            [ngClass]="['nav-item', 'nav-' + link.name.replaceAll(' ', '-').toLowerCase()]"
            [class.isParentItem]="link?.isParent"
          >
            <ng-container
              [ngTemplateOutlet]="linkTemplate"
              [ngTemplateOutletContext]="{ $implicit: link }"
            ></ng-container>
          </li>

          <li
            *ngFor="let sublink of link?.children"
            (click)="onHeaderLinkClicked(sublink)"
            [ngClass]="[
              'nav-item',
              'nav-' + link.name.replaceAll(' ', '-').toLowerCase(),
              'nav-child',
              'nav-child-' + link.name.replaceAll(' ', '-').toLowerCase()
            ]"
          >
            <ng-container
              [ngTemplateOutlet]="linkTemplate"
              [ngTemplateOutletContext]="{ $implicit: sublink }"
            ></ng-container>
          </li>
        </ng-container>

        <!-- branded menu toggler -->
        <li class="nav-item" (click)="onMovieMenu = true">
          <a class="menu-toggler" i18n="@@public.header.menu-toggler" data-translate="public.header.menu-toggler"
            >Back to movie menu</a
          >
        </li>

        <!-- SEARCH IN COLLAPSE MENU -->
        <li *ngIf="headerSMsearchCollapse" class="search-collapse">
          <!-- <ush-search-movie [mode]="'desktop'"></ush-search-movie> -->
        </li>
      </ul>
    </div>
    <!-- branded movie menu -->
    <div class="header-collapse-items header-movie-menu" [class.collapsed]="isCollapse && onMovieMenu">
      <ul>
        <li
          *ngFor="let link of brandedPageLinks"
          [ngClass]="{ active: link.isActive }"
          class="nav-item menu-{{ link.name | kebabCase }}"
        >
          <ng-container *ngIf="!link?.isExternal">
            <a *ngIf="link?.label" (click)="gotoSection(link)">
              <span [attr.data-translate]="link.label">{{ link.label }}</span></a
            >
            <a *ngIf="!link?.label" (click)="gotoSection(link)">
              <span [attr.data-translate]="'movie-template-a.menu.' + (link.name | cammelCase)">
                {{ link.name }}
              </span>
            </a>
          </ng-container>
          <ng-container *ngIf="link?.isExternal">
            <a *ngIf="link?.label" [href]="link.link" target="_blank">
              <span [attr.data-translate]="link.label">
                {{ link.label }}
              </span>
            </a>
            <a *ngIf="!link?.label" [href]="link.link" target="_blank">
              <span [attr.data-translate]="'movie-template-a.menu.' + (link.name | cammelCase)">
                {{ link.name }}
              </span>
            </a>
          </ng-container>
        </li>

        <li class="nav-item menu-toggler-list-item" (click)="onMovieMenu = false">
          <a class="menu-toggler" data-translate="public.header.menu-toggler-branded">{{
            brandedLabel(brandedMovie?.trTitle)
          }}</a>
        </li>
        <li class="menu-social-links-list-item">
          <ush-social-links [socialNetworks]="brandedMovie?.socialNetworks" [movie]="brandedMovie"></ush-social-links>
        </li>
        <ng-container *ngIf="hasTranslationHeaderSM">
          <li>
            <ush-language-selector></ush-language-selector>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
</ng-template>

<ng-template #logo let-class="class">
  <!-- supporting optional logo link coming form environment file -->
  <a
    class="nav-logo nav-link"
    (click)="onHeaderLogoClicked()"
    [ngClass]="class"
    *ngIf="!logoLinkExternal"
    [routerLink]="logoLink"
    [fragment]="logoFragment"
    (click)="onGoHome()"
  >
    <img id="logo" [src]="logoUrl | img: logoParams" [alt]="channel?.name + ' logo'" />
  </a>
  <a class="nav-logo nav-link" [ngClass]="class" *ngIf="logoLinkExternal" [href]="logoLink" target="_blank">
    <img id="logo" [src]="logoUrl | img: logoParams" [alt]="channel?.name + ' logo'" />
  </a>
  <!-- end supporting optional logo block -->
</ng-template>

<ng-template #linkTemplate let-link let-class="class" let-isParent="isParent" let-isChild="isChild">
  <a
    *ngIf="!link?.isExternal"
    [attr.data-external]="link?.isExternal || false"
    [routerLink]="(!link?.isParent && !link?.isPopup && !link?.isExternal ? link.link : null) | normalizeRoute"
    [queryParams]="link?.params"
    [fragment]="link?.fragment"
    aria-current="page"
    [ngClass]="{
      active: link.isActive,
      hasLink: link?.link,
      isParent: isParent,
      isChild: isChild,
      'nav-link-sub-menu': isChild
    }"
    class="nav-link bold"
    [attr.data-testid]="'header-link-' + (link.link || link.name | cammelCase)"
    (click)="onLinkClick(link)"
    [attr.data-translate]="'public.header.link.channel.' + (link.name | cammelCase)"
  >
    <span>
      {{ link.name | cammelCase | channelLinkLocalize: link.name }}
    </span>

    <i class="pi pi-chevron-down" *ngIf="isParent"></i>
  </a>
  <a
    *ngIf="link?.isExternal"
    [attr.data-external]="link?.isExternal || false"
    [href]="link?.isExternal ? link.link : null"
    target="_blank"
    class="nav-link bold"
    [attr.data-testid]="'header-link-' + link.link"
    aria-current="page"
    [ngClass]="{ hasLink: link?.link, isParent: isParent, isChild: isChild, 'nav-link-sub-menu': isChild }"
    (click)="onLinkClick(link)"
    [attr.data-translate]="'public.header.link.channel.' + (link.name | cammelCase)"
  >
    <span>
      {{ link.name | cammelCase | channelLinkLocalize: link.name }}
    </span>
  </a>
</ng-template>

<ng-template #loginButton>
  @if (isCommunityFeaturesEnabled || isLoginPopUpEnabled) {
    <ush-user-dropdown-community></ush-user-dropdown-community>
  } @else {
    <ush-user-dropdown></ush-user-dropdown>
  }
</ng-template>
